import React, { useState, useEffect, useMemo } from 'react'
import Text from '../../atoms/text/Text'
import VerticalGroup from '../../atoms/verticalgroup/VerticalGroup'
import InlineGroup from '../../atoms/inlinegroup/InlineGroup'
import ResultsTable from './table/ResultsTable'
import Image from '../../atoms/image/Image'
import ArcherMan from '../../../assets/results/ArcherMan.png'
import CourtRoomAngry from '../../../assets/results/CourtRoomAngry.png'
import { TeamsWithColours } from './RoundResults'
import { thousandSeparator } from '../model/utils/formatters'

import './RoundResultsTablePage.scss'

interface Props {
  teams: TeamsWithColours[]
  riskIncidentsClosing: ModelAPI.Reporting.RiskIncidentsClosing
  currencyDenomination: string
}

const RoundResultsRiskIncidentsClosing: React.FC<Props> = ({ riskIncidentsClosing, teams, currencyDenomination }) => {
  const [show, setShow] = useState(false)

  const { sortedCapitalFromHighestToLowest } = useMemo(() => {
    const sortedCapitalFromHighestToLowest = riskIncidentsClosing.data.filter((a) => a.incident > 0).sort((a, b) => b.incident - a.incident)
    return { sortedCapitalFromHighestToLowest }
  }, [riskIncidentsClosing.data])

  useEffect(() => {
    let timer = setTimeout(() => setShow(true), 2000)

    return () => clearTimeout(timer)
  }, [show])

  return (
    <>
      {sortedCapitalFromHighestToLowest.length === 0 ? (
        <VerticalGroup full center wide>
          <Text size='6xl' bold colour='primaryDark'>
            Breaking News!
          </Text>
          <Text size='4xl' bold colour='blue' center>
            All banks have made good progress on non-financial risk management.
          </Text>
          <InlineGroup fullHeight center verticalCenter>
            <Image src={ArcherMan} alt='Archor Man' style={{width: '55%'}}></Image>
          </InlineGroup>
        </VerticalGroup>
      ) : (
        <VerticalGroup full center wide>
          <Text size='6xl' bold colour='primaryDark' className='mb-2'>
            Breaking News!
          </Text>
          <Text size='4xl' bold colour='blue' center className='mb-4'>
            Regulatory imposes capital penalty on banks with insufficent risk management process.
          </Text>
          <InlineGroup spread fullHeight>
            <VerticalGroup spread style={{ width: '100%', height: '100%' }}>
              <VerticalGroup>
                <InlineGroup block center>
                  <Text size='3xl' bold>
                  Penalty Detail
                  </Text>
                </InlineGroup>
                <VerticalGroup>
                  <Text size='lg' className='mb-2 mt-4 pr-2'>
                  The Banking regulator has levied an additional '${thousandSeparator(riskIncidentsClosing.capital)}' capital required on each bank that has not been able to reduce unresolved risk incidents below '${thousandSeparator(riskIncidentsClosing.risk_incidents_below)}.'
                  </Text>
                  <Text size='lg' className='pr-10'>
                  When banks are able to reduce incidents below.
                  </Text>
                </VerticalGroup>
              </VerticalGroup>
              <InlineGroup block verticalCenter center>
                <Image src={CourtRoomAngry} alt='Court Room' width='60%' height='100%'></Image>
              </InlineGroup>
            </VerticalGroup>
            <VerticalGroup style={{ width: '100%', height: '100%' }} className={show ? 'show-options' : 'no-show-options'}>
              <ResultsTable id='999'>
                <thead>
                  <tr>
                    <th>BANK</th>
                    <th>INCIDENTS #</th>
                    <th>+ CAPITAL ({currencyDenomination})</th>
                  </tr>
                </thead>
                <tbody>
                  {sortedCapitalFromHighestToLowest.map((cap, i) => {
                    const teamForTable = teams.find((t) => t.teamId === cap.teamId)

                    return (
                      <tr key={i} style={{ animationDelay: `${sortedCapitalFromHighestToLowest.length - i}s` }}>
                        <td style={{ color: `${teamForTable?.colour}` }}>{teamForTable?.teamName}</td>
                        <td>{thousandSeparator(cap.incident)}</td>
                        <td>{thousandSeparator(riskIncidentsClosing.capital)}</td>
                      </tr>
                    )
                  })}
                </tbody>
              </ResultsTable>
            </VerticalGroup>
          </InlineGroup>
        </VerticalGroup>
      )}
    </>
  )
}

export default RoundResultsRiskIncidentsClosing
